import { render, staticRenderFns } from "./financesDetail.vue?vue&type=template&id=3595e430&"
import script from "./financesDetail.vue?vue&type=script&lang=js&"
export * from "./financesDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports